import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
import { mockable } from '@datadog/browser-core';
import { reportScriptLoadingError } from '../domain/scriptLoadingError';
export function lazyLoadProfiler() {
  return _lazyLoadProfiler.apply(this, arguments);
}
function _lazyLoadProfiler() {
  _lazyLoadProfiler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return mockable(importProfiler)();
        case 1:
          return _context.abrupt("return", _context.sent);
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          reportScriptLoadingError({
            error: _t,
            source: 'Profiler',
            scriptType: 'module'
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _lazyLoadProfiler.apply(this, arguments);
}
export function importProfiler() {
  return _importProfiler.apply(this, arguments);
}
function _importProfiler() {
  _importProfiler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var module;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return import(/* webpackChunkName: "profiler" */'../domain/profiling/profiler');
        case 1:
          module = _context2.sent;
          return _context2.abrupt("return", module.createRumProfiler);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _importProfiler.apply(this, arguments);
}